import React from 'react'
import '../../Styles/S_section.css'
import  future from '../../Assets/Pngtree3d_rocket_bilue_color_8102892.png'
import meta from '../../Assets/22434660_6594175.png'
function SecondProject() {
  return (
    <div className='second_section'>  
    <div className='ss_container'>
<div className='second_title'>
WE ARE THE FUTURE
</div>
<div className="img_f_container">
    <img src={future} alt="" className='img_f' />
</div>
<div className='second_des'>
    <p className='des_in'>
    We are building a digital universe through cutting edge of new technology,
apps and website worldwide.
    </p>

</div>

<div className="img_s">
    <img src={meta} alt="" className='img_s' />
</div>
    </div>
      
        
        </div>
  )
}

export default SecondProject